import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { BTariffTypeEnum } from '@/types/backend';
import PracticalLine from '../../PracticalLine';
import ExperiencePriceContent from './ExperiencePriceContent';
const ExperiencePrice = (t0) => {
    const $ = _c(7);
    const { price, hasSpecialTariffs } = t0;
    const translate = useTranslate();
    let t1;
    bb0: {
        if (hasSpecialTariffs && price.type === BTariffTypeEnum.Default) {
            const standardTariff = translate("practical.price.standard-tariff");
            t1 = `${price.name} ${standardTariff}`;
            break bb0;
        }
        t1 = price.name;
    }
    const tariffName = t1;
    let t2;
    if ($[0] !== price || $[1] !== tariffName) {
        t2 = <ExperiencePriceContent {...price} tariffName={tariffName}/>;
        $[0] = price;
        $[1] = tariffName;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    let t3;
    if ($[3] !== price.nameFr || $[4] !== t2 || $[5] !== tariffName) {
        t3 = <PracticalLine key={price.nameFr} label={tariffName} content={t2}/>;
        $[3] = price.nameFr;
        $[4] = t2;
        $[5] = tariffName;
        $[6] = t3;
    }
    else {
        t3 = $[6];
    }
    return t3;
};
export default ExperiencePrice;
